import { createStore } from 'vuex'
const axios = require("axios").default;

function productCode(code) {
  if (code.length == 8) {
    return code.substring(0, 3) + "." + code.substring(3, 5) + "." + code.substring(5);
  } else {
    return code;
  }
}
const store = createStore({
  state: {
    router: null,
    redirectAdminLink: null,
    adminLogin: null,
    productsAdmin: [],
    categoriesAdmin: [],
    loadingProductAdmin: [],
    loadingProductAdminError: {},
    loadingCategoryAdmin: [],
    loadingCategoryAdminError: {},
    articlesAdmin: [],
    articleGroupAdmin: [],
    loadingArticleAdmin: [],
    loadingArticleAdminError: {},
    loadingArticleGroupAdmin: [],
    loadingArticleGroupAdminError: {},
    loadingProduct: {},
    products: {},
    loadingBlog: false,
    blogs: null,
    navData: null,
    loadingNav: false,
    randomProducts: null,
    loadingRandom: false,
    loadingProductByCate: {},
    productByCate: {},
    loadingCate: {},
    cate: {},
    cart: [],
    homeModules: null,
    loadingHomeModules: false,
  },
  getters: {
    homeModules(state) {
      if (state.homeModules == null) {
        if (!state.loadingHomeModules) {
          store.commit("getHomeModules");
        }
        return [];
      } else {
        return state.homeModules;
      }
    },
    cart(state) {
      return state.cart;
    },
    product(state) {
      return function (product_id) {
        if (state.products[product_id]) {
          return state.products[product_id];
        } else {
          if (!state.loadingProduct[product_id]) {
            store.commit("loadProduct", product_id);
          }
          return null;
        }
      }
    },
    cate(state) {
      return function (cate_id) {
        if (state.cate[cate_id]) {
          return state.cate[cate_id];
        } else {
          if (!state.loadingCate[cate_id]) {
            store.commit("loadCate", cate_id);
          }
          return null;
        }
      }
    },
    productsByCate(state) {
      return function (cate_id) {
        if (state.productByCate[cate_id]) {
          return state.productByCate[cate_id];
        } else {
          if (!state.loadingProductByCate[cate_id]) {
            store.commit("loadProductsByCate", cate_id);
          }
          return [];
        }
      }
    },
    randomProducts(state) {
      if (!state.randomProducts) {
        if (!state.loadingRandom) {
          store.commit("loadRandomProducts");
        }
        return [];
      }
      return state.randomProducts;
    },

    navData(state) {
      if (state.navData == null) {
        if (!state.loadingNav) {
          store.commit("loadNav");
        }
        return null;
      } else {
        return state.navData;
      }
    }, blogs(state) {
      if (state.blogs == null) {
        if (!state.loadingBlog) {
          store.commit("loadBlog");
        }
        return [];
      } else {
        return state.blogs;
      }
    },
    blog(state) {
      if (state.blogs == null) {
        if (!state.loadingBlog) {
          store.commit("loadBlog");
        }
        return function () {
          return null;
        };
      } else {
        return function (id) {
          return state.blogs.find(i => i._id == id);
        };
      }
    },
    productAdmin(state) {
      return function (productId, lastUpdate) {
        if (state.loadingProductAdmin.indexOf(productId) != -1 ||
          (typeof state.loadingProductAdminError[productId] == 'number' && state.loadingProductAdminError[productId] + 5000 > Date.now())) {
          return null;
        } else {
          let product = state.productsAdmin.find(i => i._id.toLowerCase() == productId.toLowerCase());
          if (product) {
            if (typeof lastUpdate != "undefined") {
              if (product.lastUpdate == lastUpdate) {
                return product;
              } else {
                state.productsAdmin.splice(state.productsAdmin.indexOf(product), 1);
              }
            } else {
              return product;
            }
          }
          store.commit("loadProductAdmin", productId);
          return null;
        }
      }
    },
    categoryAdmin(state) {
      return function (categoryId, lastUpdate) {
        if (state.loadingCategoryAdmin.indexOf(categoryId) != -1 ||
          (typeof state.loadingCategoryAdminError[categoryId] == 'number' && state.loadingCategoryAdminError[categoryId] + 5000 > Date.now())) {
          return null;
        } else {
          let category = state.categoriesAdmin.find(i => i._id.toLowerCase() == categoryId.toLowerCase());
          if (category) {
            console.log(category);
            if (typeof lastUpdate != "undefined") {
              if (category.lastUpdate == lastUpdate) {
                return category;
              } else {
                state.categoriesAdmin.splice(state.categoriesAdmin.indexOf(category), 1);
              }
            } else {
              return category;
            }
          }
          store.commit("loadCategoryAdmin", categoryId);
          return null;
        }
      }
    },
    categoryAdmin2(state) {
      return function (categoryId) {
        categoryId = categoryId.trim();
        console.log(categoryId);
        if (state.loadingCategoryAdmin.indexOf(categoryId) != -1 ||
          (typeof state.loadingCategoryAdminError[categoryId] == 'number' && state.loadingCategoryAdminError[categoryId] + 5000 > Date.now())) {
          return null;
        } else {
          let category = state.categoriesAdmin.find(i => i._id.toLowerCase() == categoryId.toLowerCase());
          console.log(category);
          if (category) {
            return state.categoriesAdmin.splice(state.categoriesAdmin.indexOf(category), 1);
          } else {
            store.commit("loadCategoryAdmin", categoryId);
          }
          return null;
        }
      }
    },

    articleAdmin(state) {
      return function (articleId, lastUpdate) {
        if (state.loadingArticleAdmin.indexOf(articleId) != -1 ||
          (typeof state.loadingArticleAdminError[articleId] == 'number' && state.loadingArticleAdminError[articleId] + 5000 > Date.now())) {
          return null;
        } else {
          let article = state.articlesAdmin.find(i => i._id == articleId);
          if (article) {
            if (typeof lastUpdate != "undefined") {
              if (article.lastUpdate == lastUpdate) {
                return article;
              } else {
                state.articlesAdmin.splice(state.articlesAdmin.indexOf(article), 1);
              }
            } else {
              return article;
            }
          }
          store.commit("loadArticleAdmin", articleId);
          return null;
        }
      }
    },
    articleGroupAdmin(state) {
      return function (categoryId, lastUpdate) {
        if (state.loadingArticleGroupAdmin.indexOf(categoryId) != -1 ||
          (typeof state.loadingArticleGroupAdminError[categoryId] == 'number' && state.loadingArticleGroupAdminError[categoryId] + 5000 > Date.now())) {
          return null;
        } else {
          let category = state.categoriesAdmin.find(i => i._id == categoryId);
          if (category) {
            if (typeof lastUpdate != "undefined") {
              if (category.lastUpdate == lastUpdate) {
                return category;
              } else {
                state.categoriesAdmin.splice(state.categoriesAdmin.indexOf(category), 1);
              }
            } else {
              return category;
            }
          }
          store.commit("loadArticleGroupAdmin", categoryId);
          return null;
        }
      }
    }
  },
  mutations: {
    async getHomeModules(state) {

      try {
        state.loadingHomeModules = true;
        let res = await axios.get("/api/modules/home");
        state.homeModules = res.data;
      } finally {
        state.loadingHomeModules = false;
      }
      
    },
    setRouter(state, router) {
      state.router = router;
    },
    adminLink(state, link) {
      state.redirectAdminLink = link;
    },
    addToCart(state, product_id) {
      let p = state.cart.find(i => i._id == product_id);
      if (typeof p == "undefined") {
        state.cart.push({ _id: product_id, quantity: 1 });
      } else {
        p.quantity++;
      }
      window.localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    updateCart(state, { code, num }) {
      let p = state.cart.find(i => i._id == code);
      if (typeof p == "undefined") {
        if (Math.round(num) > 0) {
          state.cart.push({ _id: code, quantity: num });
        }
      } else {
        if (typeof num == "number") {
          if (Math.round(num) > 0) {
            p.quantity = num;
          } else {
            state.cart.splice(state.cart.indexOf(p), 1);
          }

        }
      }
      window.localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    loadCartFromLocalStorage(state) {
      let cart = window.localStorage.getItem("cart");
      if (cart) {
        state.cart = JSON.parse(cart);
      }
    },
    async loadProduct(state, product_id) {
      try {
        state.loadingProduct[product_id] = true;
        let res = await axios.get("/api/product/" + product_id);
        state.products[product_id] = res.data;
      } finally {
        state.loadingProduct[product_id] = false;
      }
    },
    async loadCate(state, cate_id) {
      try {
        state.loadingCate[cate_id] = true;
        let res = await axios.get("/api/cate/" + cate_id);
        state.cate[cate_id] = res.data;
      } finally {
        state.loadingCate[cate_id] = false;
      }
    },
    async loadProductsByCate(state, cate_id) {
      try {
        state.loadingProductByCate[cate_id] = true;
        let res = await axios.get("/api/products/cate/" + cate_id);
        state.productByCate[cate_id] = res.data.map(i => productCode(i.code));
      } finally {
        state.loadingProductByCate[cate_id] = false;
      }
    },
    async loadRandomProducts(state) {
      try {
        state.loadingRandom = true;
        let res = await axios.get("/api/products/random");
        console.log(res.data);
        state.randomProducts = res.data.map(i => productCode(i.code));
        console.log(state.randomProducts);
      } finally {
        state.loadingRandom = false;
      }
    },
    async loadNav(state) {

      try {
        let res = await axios.get("/api/nav");
        state.navData = res.data;
      } finally {
        state.loadingNav = false;
      }
    },
    async loadBlog(state) {
      try {
        let res = await axios.get("/api/blogs");
        state.blogs = res.data;
      } finally {
        state.loadingBlog = false;
      }
    },
    async loadProductAdmin(state, productId, force=false) {
      if (state.loadingProductAdmin.indexOf(productId) == -1 || force) {
        state.loadingProductAdmin.push(productId);
        try {
          let res = await axios.get("/aapi/product/" + encodeURIComponent(productId));
          let check = state.productsAdmin.find(i => i._id == productId);
          if(check) {
            state.productsAdmin.splice(state.productsAdmin.indexOf(check), 1);
          }
          state.productsAdmin.push(res.data);
        } catch {
          state.loadingProductAdminError[productId] = Date.now();
        } finally {
          state.loadingProductAdmin.splice(state.loadingProductAdmin.indexOf(productId), 1);
        }
      }
    },
    async loadCategoryAdmin(state, categoryId) {
      if (state.loadingCategoryAdmin.indexOf(categoryId) == -1) {
        state.loadingCategoryAdmin.push(categoryId);
        try {
          let res = await axios.get("/aapi/category/" + encodeURIComponent(categoryId));
          console.log(res.data);
          state.categoriesAdmin.push(res.data);
        } catch {
          state.loadingCategoryAdminError[categoryId] = Date.now();
        } finally {
          state.loadingCategoryAdmin.splice(state.loadingCategoryAdmin.indexOf(categoryId), 1);
        }
      }
    },
    login(state, data) {
      state.adminLogin = data;
      if (state.redirectAdminLink) {
        //window.location.assign(state.redirectAdminLink);
        console.log(state.redirectAdminLink);
        if (state.redirectAdminLink != "/admin/login") {
          console.log(state.router);
          console.log(state.redirectAdminLink);
          state.router.push(state.redirectAdminLink);

        }
        state.redirectAdminLink = null;

      }
    },

    async loadArticleAdmin(state, articleId) {
      if (state.loadingArticleAdmin.indexOf(articleId) == -1) {
        state.loadingArticleAdmin.push(articleId);
        try {
          let res = await axios.get("/aapi/article/" + encodeURIComponent(articleId));
          console.log(res);
          state.articlesAdmin.push(res.data);
        } catch {
          state.loadingArticleAdminError[articleId] = Date.now();
        } finally {
          state.loadingArticleAdmin.splice(state.loadingArticleAdmin.indexOf(articleId), 1);
        }
      }
    },
    async loadArticleGroupAdmin(state, articleGroupId) {
      if (state.loadingArticleGroupAdmin.indexOf(articleGroupId) == -1) {
        state.loadingArticleGroupAdmin.push(articleGroupId);
        try {
          let res = await axios.get("/aapi/article-group/" + encodeURIComponent(articleGroupId));
          console.log(res);
          state.categoriesAdmin.push(res.data);
        } catch {
          state.loadingArticleGroupAdminError[articleGroupId] = Date.now();
        } finally {
          state.loadingArticleGroupAdmin.splice(state.loadingArticleGroupAdmin.indexOf(articleGroupId), 1);
        }
      }
    },
  },
  actions: {
  },
  modules: {
  }
});
store.commit("loadCartFromLocalStorage");
export default store;
